import React from 'react'
import MessageScreenHeader from '../../../components/MessageScreenHeader/MessageScreenHeader'
import MessageScreenBody from '../../../components/MessageScreenBody/MessageScreenBody'
import MessageScreenFooter from '../../../components/MessageScreenFooter/MessageScreenFooter'
import ChatNotSelected from '../../../components/ChatNotSelected/ChatNotSelected'

function BodyRender({ selectedAssignedList }) {
  if (typeof selectedAssignedList === 'object' && Object.keys(selectedAssignedList).length === 0) {
    return <ChatNotSelected />
  } else {
    return (
      <React.Fragment>
        <MessageScreenHeader className="chats__msg-screen-header"
          // setDispose={setDispose}
          // setActiveTab={setActiveTab}
        />
        <MessageScreenBody className="chats__msg-screen-body" />
        <MessageScreenFooter
          // dispose={dispose}
          // activeTab={activeTab}
          // setDispose={setDispose}
          // setActiveTab={setActiveTab}
        />
      </React.Fragment>
    )
  }
}

export default BodyRender


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/modules/middleContent/Chats/BodyRender.js